interface DownloadFileProps {
  response: Response;
  fileName: string;
}

/**
 * @param param0 - An object containing the response from a fetch request and the desired file name for download.
 * @returns A promise that resolves when the file has been downloaded.
 */
export async function downloadFile({ response, fileName }: DownloadFileProps) {
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');

  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
